<div class="reservations-report-page">
  <app-reservations-report-header
    [resultCount]="filteredRows.length"
    [loadedCount]="loadedCount"
    [activeFilterCount]="activeFilterCount"
    [isLoading]="isBusy"
    [isLoadingMore]="isLoadingMore"
    (refresh)="loadReservations()"
  ></app-reservations-report-header>

  <app-reservations-report-filters
    [filters]="filters"
    [filterOptions]="filterOptions"
    [activeFilterChips]="activeFilterChips"
    [disabled]="isInitialLoading"
    (filtersChange)="onFiltersChange($event)"
    (clearAll)="onClearFilters()"
    (removeFilter)="onRemoveFilter($event)"
  ></app-reservations-report-filters>

  <app-reservations-report-table
    [rows]="filteredRows"
    [isLoading]="isInitialLoading"
    [isLoadingMore]="isLoadingMore"
    [loadedCount]="loadedCount"
    [totalCount]="filteredRows.length"
    (openPdf)="onOpenPdf($event)"
  ></app-reservations-report-table>
</div>
